import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Company } from "../models/company"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'company/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllCompany(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<Company>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllCompany?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewCompany(CompanyID?: string): Observable<Array<Company>> {
    return this.httpService.get(this.apiEndpoint + 'viewCompany/' + (CompanyID ? CompanyID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveCompany(companys: Company): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveCompany/', companys).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkEmail(Emailid?: string, CompanyId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkEmail?Emailid=' + (Emailid ? Emailid : '')+ '&CompanyId=' + (CompanyId ? CompanyId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      return result;
    })); 
  }

  deleteCompany(CompanyID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteCompany/' + (CompanyID ? CompanyID : '00000000-0000-0000-0000-000000000000'), CompanyID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(CompanyName?: string,CompanyId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?CompanyName=' + (CompanyName ? CompanyName : '')+ '&CompanyId=' + (CompanyId ? CompanyId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
